const styles = () => ({
  root: {
    width: '720px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },

  header: {
    width: '100%',
    padding: '20px 40px',
    borderBottom: '1px solid #e1e6eb',
  },

  body: {
    flex: '1 0 auto',
    background: '#fafbfc',
  },

  title: {
    color: '#27282a',
    fontSize: '24px',
    fontWeight: 600,
    margin: '0 0 5px',
  },

  confirmationHeader: {
    borderBottom: '1px solid #e1e6eb',
  },

  confirmationFooter: {
    marginTop: '30px',
  },

  confirmationContentBox: {
    background: '#fff',
    border: '1px solid #e1e6eb',
    borderRadius: 8,
    margin: '30px',
    padding: '20px 0 30px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    '& *': {
      flexGrow: 1,
      lineHeight: 1.4,
    },
    '& svg': {
      marginBottom: 10,
    },
    '& h1': {
      color: '#27282a',
      fontSize: 15,
      fontWeight: 500,
    },
    '& p': {
      color: '#596168',
      fontSize: 14,
      margin: '4px 95px 32px 95px',
      '& span': {
        color: '#27282a',
        fontWeight: 500,
      },
    },
  },

  // Form
  formInner: {
    margin: '30px',
    background: '#fff',
    border: '1px solid #e1e6eb',
    borderRadius: '6px',

    '& label': {
      marginBottom: '10px',
    },
  },

  formOuter: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },

  field: {
    margin: '30px',
  },

  contactInfo: {
    borderBottom: '1px solid #e1e6eb',
    display: 'flex',
  },

  planOptions: {
    padding: '30px',
    borderBottom: '1px solid #e1e6eb',
  },

  choosePlan: {
    margin: '0px 0px 20px',
  },

  planOption: {
    display: 'flex',
    margin: '10px 0px',
  },

  checkbox: {
    marginRight: '20px',
    padding: 0,
    alignItems: 'baseline',
  },

  optionName: {
    color: '27282a',
    fontWeight: 500,
    marginBottom: '5px',
  },

  optionDescription: {
    color: '#596168',
    margin: 0,
  },

  message: {
    display: 'flex',
  },
});

export default styles;
